import React from "react";
import style from "./index.module.scss";
import { CourseItem } from "../../../../../../API";
import DayCell from "./components/DayCell";
import { Empty } from "antd";

interface DayCalendarProps {
    courses: CourseItem[];
    dateTime: string;
}

export default function DayCalendar({ courses, dateTime }: DayCalendarProps) {
    return (
        <div className={style.root}>
            {courses.map((item, index) => (
                <DayCell
                    key={item.weekTimeId}
                    course={item}
                    dateTime={dateTime}
                />
            ))}
            {courses.length === 0 && (
                <Empty description="今天没有课" className={style.empty} />
            )}
        </div>
    );
}
